import { render } from "./CertificateWarning.vue?vue&type=template&id=3ebcf0aa&scoped=true"
const script = {}

import "./CertificateWarning.vue?vue&type=style&index=0&id=3ebcf0aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebcf0aa"]])

export default __exports__